// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","footer__btn":"Footer_footer__btn__RuPuR"};